﻿/****************************************
	person-view.js
*****************************************/
/* Globals */
var $html = $('html'),
	$pageHeader = $('.pageHeader'),
	$pageWrap = $('.pageWrap'),
	$printFriendlyActions = $('#printFriendlyActions'),
	$sideDrawer = $('#sideDrawer'),
	$triggerToggleSideDrawer,
	cloneComments = true,
	commentWidgetHasLoaded = false,
	notifyRecordObject = null,
	personViewModalAlertSettingsNote = {
		'onClose': function () {
			'use strict';
			$.autocomplete.position();
		},
		'onOpen': function () {
			'use strict';
			$.autocomplete.position();
		},
		'open': false,
		'type': 'note'
	},
	personViewModalAlertSettingsInfo = {
		'onClose': function () {
			'use strict';
			$.autocomplete.position();
		},
		'onOpen': function () {
			'use strict';
			$.autocomplete.position();
		},
		'open': false,
		'type': 'info'
	},
	personViewModalAlertSettingsSuccess = {
		'onClose': function () {
			'use strict';
			$.autocomplete.position();
		},
		'onOpen': function () {
			'use strict';
			$.autocomplete.position();
		},
		'open': false,
		'type': 'success',
		'duration': 3000
	},
	personViewModalAlertSettingsWarning = {
		'onClose': function () {
			'use strict';
			$.autocomplete.position();
		},
		'onOpen': function () {
			'use strict';
			$.autocomplete.position();
		},
		'open': false,
		'type': 'warning'
	},
	showingComments = false,
	showingNotes = false;
/* Get AJAX Url Prefix */
function getPersonAjaxUrlPrefix() {
	'use strict';
	var onWww = window.location.hostname.substring(0, 12) === 'www.ancestry';
	return onWww ? '/family-tree/person' : '';
}
function updateHintCount(data) {
	'use strict';
	var hintCount = data;
	if (hintCount <= 0) {
		$('#tabHintCount').remove();
	} else {
		if (hintCount > 99) {
			hintCount = '99+';
		}
		if ($('#tabHintCount').length >= 1) {
			$('#tabHintCount').text(hintCount);
		} else {
			$('#tabHints').append('<span class="badge" id="tabHintCount">' + hintCount + '</span>');
		}
		/* Re-initialize the tabs as they may now need to go into horizontal scrolling mode with the extra width from the hints count. */
		$('#personTabs').tabs();
	}
}
/* Determines the view in context and retrieves data associated with that view. */
function getTabData(tabName) {
	'use strict';
	var data = {};
	switch (tabName) {
		/* Story */
		case 'story':
		case 'tabStory':
			data.tabId = 'tabStory';
			data.contentId = 'tabContentStory';
			data.url = getPersonAjaxUrlPrefix() + window.PersonCard.URL.story;
			data.domId = 'personPageStory';
			data.key = 'story';
			data.queryValue = 'story';
			data.events = {};
			data.tab = tabName;
			break;
		/* Facts */
		case 'facts':
		case 'tabFacts':
			data.tabId = 'tabFacts';
			data.contentId = 'tabContentFacts';
			data.url = getPersonAjaxUrlPrefix() + window.PersonCard.URL.facts;
			data.domId = 'personPageFacts';
			data.key = 'facts';
			data.queryValue = 'facts';
			data.events = {};
			data.tab = tabName;
			break;
		/* Gallery */
		case 'gallery':
		case 'tabGallery':
			data.tabId = 'tabGallery';
			data.contentId = 'tabContentGallery';
			data.url = window.PersonCard.loadHintsAndMediaFromUIServers ? window.PersonCard.URL.gallery : getPersonAjaxUrlPrefix() + window.PersonCard.URL.gallery;
			data.domId = 'personPageGallery';
			data.key = 'gallery';
			data.queryValue = 'gallery';
			data.events = {};
			data.tab = tabName;
			break;
		/* Hints */
		case 'hints':
		case 'tabHints':
			data.tabId = 'tabHints';
			data.contentId = 'tabContentHints';
			data.url = window.PersonCard.loadHintsAndMediaFromUIServers ? window.PersonCard.URL.hints : getPersonAjaxUrlPrefix() + window.PersonCard.URL.hints;
			data.domId = 'personPageHints';
			data.key = 'hints';
			data.queryValue = 'hints';
			data.events = {
				'PersonHintTab::hintcount_change::pending': function (nData) {
					updateHintCount(nData);
				}
			};
			data.tab = tabName;
			break;
	}
	return data;
}
function htmlDecode(s) {
	'use strict';
	var div = document.createElement('div');
	div.innerHTML = s.replace(/<\/?[^>]+>/gi, '');
	return div.childNodes[0] ? div.childNodes[0].nodeValue : '';
}
/* Determines the tab name for page title */
function getTabNameStringForPageTitle(tabName) {
	'use strict';
	switch (tabName) {
		/* Story */
		case 'story':
			return window.PersonCard.text.lifeStoryTabName;
		/* Facts */
		case 'facts':
			return window.PersonCard.text.factsTabName;
		/* Gallery */
		case 'gallery':
			return window.PersonCard.text.galleryTabName;
		/* Hints */
		case 'hints':
			return window.PersonCard.text.hintsTabName;
	}
}
function UpdateURL(history, data) {
	'use strict';
	if (window.PersonCard !== undefined) {
		/* if there is not a tabname, then add it, but make sure it comes before args if they exist */
		var urlArray = history.url.split('?', 2),
			curTab = '/' + window.PersonCard.tabName.toLowerCase();
		if (!urlArray[0].toLowerCase().endsWith(curTab)) {
			urlArray[0] += curTab;
		}
		var newUrl = urlArray.join('?');
		/* Setup events of initial rendered component */
		if (data && data.events && window.acom && window.acom.bus) {
			Object.keys(data.events).forEach(function (event) {
				window.acom.bus.on(event, data.events[event]);
			});
		}
		History.replaceState(data, htmlDecode(window.PersonCard.name) + ' - ' + getTabNameStringForPageTitle(window.PersonCard.tabName), newUrl);
	}
}
function loadScripts(scriptsToLoad, callback) {
	'use strict';
	var remainingScriptsToLoad = scriptsToLoad.slice();
	if (remainingScriptsToLoad.length === 0) {
		if (callback) {
			callback();
		}
	} else {
		var scriptToLoad = remainingScriptsToLoad.splice(0, 1)[0];
		$.cachedScript(scriptToLoad, { success: function () { loadScripts(remainingScriptsToLoad, callback); } });
	}
}
/* Print Comments */
function cloneCommentsForPrinting() {
	'use strict';
	if (cloneComments === true) {
		cloneComments = false;
		$('#printFriendlyComments').empty();
		$('#personCommentsSection .comment.userCard:not(.addComment):not(.signIn)').each(function () {
			var $this = $(this),
				userCardContent = $this.find('.userCardContent'),
				userCardName = $this.find('.userCardName').text(),
				userCardComment = $this.find('.userCardName + span').text(),
				userCardInfo = $this.find('.userCardInfo small > span:first-child').text();
			if (userCardContent.length > 0) {
				$(
					'<div class="userCard userCardSize2 printFriendlyUserCard">' +
					'<div class="userCardImg icon iconPerson"></div>' +
					'<div class="userCardContent">' +
					'<p class="userCardComment"><strong>' + userCardName + '</strong> ' + userCardComment + '</p>' +
					'<div class="userCardInfo">' +
					'<small>' + userCardInfo + '</small>' +
					'</div>' +
					'</div>' +
					'</div>'
				).appendTo('#printFriendlyComments');
			}
		});
		cloneComments = true;
	}
}
/* Load Comments */
function loadComments() {
	'use strict';
	function loadScriptTagWithCallback(scriptSrc, callback) {
		var scriptTag = $('<script />', { src: scriptSrc, 'type': 'text/javascript' })[0];
		scriptTag.onload = callback; /* Needs to be a raw onload property (jQuery doesn't trigger this event properly) */
		document.getElementsByTagName('head')[0].appendChild(scriptTag);
	}
	/* If we have a comment-widget directive that has not been compiles (i.e. $('comment-widget').length > 0) and we haven't started loading it already... */
	if ($('comment-widget').length > 0 && $('.tabContentComments.loading').length === 0) {
		$('.tabContentComments').addClass('loading loadingLarge');
		$.get(window.PersonCard.URL.commentsCssUrl, function (commentsAssetCssUrl) {
			$('head').append($('<link />', { href: commentsAssetCssUrl, 'type': 'text/css', rel: 'stylesheet' }));
		});
		loadScriptTagWithCallback(window.PersonCard.URL.angular, function () {
			$.get(window.PersonCard.URL.commentsJsUrl, function (commentsAssetJsUrl) {
				loadScriptTagWithCallback(commentsAssetJsUrl, function () {
					angular.bootstrap($('comment-widget'), ['community']);
					$('.tabContentComments').removeClass('loading loadingLarge');
					if ($html.hasClass('pFHasComments') && $html.hasClass('printFriendly')) {
						var hasCommentsLoaded;
						hasCommentsLoaded = setInterval(function () {
							if ($('#personCommentsSection .comment').length >= 1) {
								clearInterval(hasCommentsLoaded);
								cloneCommentsForPrinting();
							}
						}, 50);
					}
					commentWidgetHasLoaded = true;
				});
			});
		});
	}
}
/* Print Check Notes */
function checkNotes() {
	'use strict';
	if ($('#printFriendlyNotes').text().length > 0) {
		$html.addClass('pFHasNotes');
	} else {
		$html.removeClass('pFHasNotes');
	}
}
/* Show Notes in Person Card */
function showNotesInPersonCard() {
	'use strict';
	if ($('.tabContentNotes [contenteditable]').text() !== '') {
		if (!$('#personCard .myNotesBtn').length) {
			var $personCardUserCardInfo = $('#personCard .userCardInfo'),
				sideDrawerExpanded = ($('.pageWrapDrawer').length) ? 'true' : 'false',
				notesButton = '<button aria-controls="sideDrawer" aria-expanded="' + sideDrawerExpanded + '" class="link icon iconNoteAlt myNotesBtn notPrintable" type="button"><span class="hideVisually">' + window.PersonCard.text.viewNotes + '</span></button>';
			if ($personCardUserCardInfo.length) {
				/* Using ".before" and ".after" removes white space while ".append" leaves it. */
				var $personCommentsBtn = $('#personCard .personCommentsBtn');
				if ($personCommentsBtn.length) {
					$personCommentsBtn.before(notesButton);
				} else {
					$personCardUserCardInfo
						.children()
						.last()
						.after(notesButton);
				}
			} else {
				$('#personCard .userCardContent').append('<div class="userCardInfo">' + notesButton + '</div>');
			}
		}
	} else {
		if ($('#personCard .myNotesBtn').length) {
			$('#personCard .myNotesBtn').remove();
			$('#personCard .userCardInfo:empty').remove();
		}
	}
}
/* Save Person Notes */
function savePersonNotes(callback) {
	'use strict';
	var notesField = $('#NotesTextAreaNoEditor'),
		pFNotesField = $('#printFriendlyNotes');
	if (notesField.length > 0) {
		var notesValOriginal = notesField.data('notes-original'),
			converted = notesField.html();
		if (notesValOriginal.length !== converted.length || notesValOriginal !== converted) {
			$('#savingChangesText').show();
			var id = notesField.data('notes-original-id'),
				savePersonNotesUrl = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/savePersonNotes';
			$.ajax({
				type: 'POST',
				cache: false,
				data: { note: converted, noteId: id },
				url: savePersonNotesUrl,
				timeout: 20000,
				success: function (data) {
					$('#savingChangesText').text(window.PersonCard.text.changesSaved);
					notesField.data('notes-original', converted);
					if (data.noteId !== undefined && data.noteId !== null) {
						notesField.data('notes-original-id', data.noteId);
					} else {
						notesField.data('notes-original-id', '');
					}
					if (window.PersonCard.showNotesInPersonCard === 'true') {
						showNotesInPersonCard();
					}
					/* Print */
					pFNotesField.html(converted);
					checkNotes();
					if (callback) {
						callback();
					}
				},
				error: function () {
					$('#savingChangesText').text(window.PersonCard.text.changesNotSaved);
					window.personAnalyticsTrackClick('savePersonNotes-Failed');
					if (callback) {
						callback();
					}
				}
			});
		}
	}
}
/* Clear text to default state for saving changes */
function clearChangesSavedText() {
	'use strict';
	if ($('#savingChangesText').is(':visible')) {
		$('#savingChangesText').hide();
		$('#savingChangesText').html(window.PersonCard.text.savingChanges);
	}
}
/* Get Person Notes */
function getPersonNotes(callback) {
	'use strict';
	var getPersonNotesUrl = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/getPersonNotes';
	$.ajax({
		url: getPersonNotesUrl,
		method: 'GET',
		cache: false,
		success: function (data) {
			if (data && data.note !== null) {
				var notesField = $('#NotesTextAreaNoEditor'),
					pFNotesField = $('#printFriendlyNotes');
				if (notesField.length > 0) {
					notesField.html(data.note);
					notesField.data('notes-original', data.note);
					if (data.noteId !== undefined && data.noteId !== null) {
						notesField.data('notes-original-id', data.noteId);
					} else {
						notesField.data('notes-original-id', '');
					}
					if (window.PersonCard.showNotesInPersonCard === 'true') {
						showNotesInPersonCard();
					}
				}
				/* Print */
				pFNotesField.html(data.note);
				checkNotes();
			}
			if (callback) {
				callback();
			}
		},
		error: function () {
			window.personAnalyticsTrackClick('getPersonNotes-Failed');
			if (callback) {
				callback();
			}
		}
	});
}
/* Close Person Notes */
function closeNotes() {
	'use strict';
	$('#savingChangesText').hide();
}
/* Print Check Notes and Comments */
function checkNotesAndComments() {
	'use strict';
	/* Print Check Comments */
	function checkComments() {
		if ($html.hasClass('pFHasComments')) {
			if (commentWidgetHasLoaded === false) {
				/* Load Comments if they have not yet been loaded */
				loadComments();
			} else {
				/* Otherwise go straight to cloning */
				cloneCommentsForPrinting();
			}
		}
	}
	if ($html.hasClass('printFriendly')) {
		if ((!$html.hasClass('pFHasNotes') && showingNotes === false) || ($html.hasClass('pFHasNotes') && $('#printFriendlyNotes').children().length === 0)) {
			getPersonNotes();
		}
		checkComments();
	} else {
		if (!$html.hasClass('pageWrapDrawer')) {
			$html.removeClass('pFShowingComments pFShowingNotes');
		} else {
			if (showingNotes === true) {
				$html.removeClass('pFShowingComments');
				$html.addClass('pFShowingNotes');
				checkNotes();
			}
			if (showingComments === true) {
				$html.removeClass('pFShowingNotes');
				$html.addClass('pFShowingComments');
			}
			checkComments();
		}
	}
}
/* Print Clear */
function clearPrintFriendly() {
	'use strict';
	$html.removeClass('printFriendly pFNoTransitions pFNoFacts pFNoFamily pFNoSources pFHidingMiniTree pFHidingMap');
	checkNotesAndComments();
}
/* Toggle Side Drawer */
function drawerIsOpen() {
	'use strict';
	return $html.hasClass('pageWrapDrawer');
}
function togglingDrawer() {
	'use strict';
	if (!window.personScreenType('smart-phone')) {
		/* Check Belay */
		if (typeof (beforeBelay) === 'function') {
			beforeBelay(false);
		}
	}
	if (typeof checkMiniProfile === 'function') {
		checkMiniProfile();
	}
}
function toggleDrawer(adjustingTop) {
	'use strict';
	var $toggleDrawerAriaExpanded = $('[aria-controls="sideDrawer"]'),
		pageWrapRectTop = parseInt($pageWrap[0].getBoundingClientRect().top),
		toggleDrawerInterval;
	/* Set top for Side Drawer */
	$sideDrawer.css('top', (pageWrapRectTop > 0) ? pageWrapRectTop + 'px' : '0px');
	if (adjustingTop) {
		return;
	}
	/* Handle Opening and Closing of Side Drawer */
	if (!$html.hasClass('pageWrapDrawer')) {
		/* Adjust top value of Side Drawer during scroll */
		$(window).on('scroll.sideDrawer', ui.throttle(function () {
			var pageWrapRectTopAfter = parseInt($pageWrap[0].getBoundingClientRect().top);
			if (pageWrapRectTop !== pageWrapRectTopAfter) {
				$sideDrawer.css('top', (pageWrapRectTopAfter > 0) ? pageWrapRectTopAfter + 'px' : '0px');
				pageWrapRectTop = pageWrapRectTopAfter;
			}
		}, 10));
		/* Do while drawer opens */
		if ($('.calloutTrigger.active').length) {
			$triggerToggleSideDrawer = $('.calloutTrigger.active');
		} else {
			$triggerToggleSideDrawer = $(':focus');
		}
		$sideDrawer.focus();
		$toggleDrawerAriaExpanded.attr('aria-expanded', 'true');
		toggleDrawerInterval = setInterval(function () {
			togglingDrawer();
		}, 10);
		/* Drawer is opening */
		$html
			.addClass('pageWrapDrawer')
			.one('webkitTransitionEnd transitionend', function () {
				/* Do after drawer opens */
				clearInterval(toggleDrawerInterval);
			});
	} else {
		/* Do while drawer closes */
		if ($('.iconClose:focus').length) {
			$triggerToggleSideDrawer.focus();
		}
		$toggleDrawerAriaExpanded.attr('aria-expanded', 'false');
		toggleDrawerInterval = setInterval(function () {
			togglingDrawer();
		}, 10);
		/* Drawer is closing */
		$html
			.removeClass('pageWrapDrawer')
			.one('webkitTransitionEnd transitionend', function () {
				/* Do after drawer closes */
				$html.removeClass('pFShowingNotes pFShowingComments');
				clearInterval(toggleDrawerInterval);
				$(window).off('scroll.sideDrawer');
			});
	}
	if (window.PersonCard.hasEditRights) {
		if (drawerIsOpen()) {
			getPersonNotes();
		} else {
			closeNotes();
		}
	}
}
/* Print After */
function afterPrint() {
	'use strict';
	$html.removeClass('pFNoTransitions');
	/* Reset View and Clear Print */
	if ($html.hasClass('printFriendly')) {
		if ($('.pageHeader').hasClass('pageHeaderStory')) {
			$('.lifeStoryFamily').removeClass('noDisplay');
			$('.lifeStoryMap').removeClass('noDisplay');
		}
		clearPrintFriendly();
	}
	/* Reverse Sections */
	if ($('.pageHeader').hasClass('pageHeaderFacts')) {
		$('.factsSectionFamily').insertAfter($('.factsSectionSources'));
	}
	/* Return Focus */
	if ($('.printFriendlyViewTriggered').length > 0) {
		$('.printFriendlyViewTriggered')
			.removeClass('printFriendlyViewTriggered')
			.focus();
	}
	/* Recheck Mini Profile */
	if (typeof checkMiniProfile === 'function') {
		checkMiniProfile();
	}
	/* Check Belay */
	if (typeof (beforeBelay) === 'function') {
		beforeBelay(false);
	}
	/* Check Side Drawer */
	if ($html.hasClass('pageWrapDrawer')) {
		toggleDrawer(true);
	}
}
/* Name Typeahead for anywhere there is a name typeahead */
function personTypeAheadNameField($typeAhead, excludepids, typeAheadSaveButton, section, showExtra) {
	'use strict';
	var hasSection = (section !== undefined && section !== null && section.length > 0),
		treeId = window.PersonCard.treeId;
	if (typeAheadSaveButton !== undefined && typeAheadSaveButton !== null && typeAheadSaveButton.length > 0) {
		/* Make sure the save button is disabled before we get the typeahead*/
		typeAheadSaveButton.attr('disabled', 'disabled');
	}
	var autoCompleteUrl = window.PersonCard.autoCompletePersonUrl.replace('{excludePids}', excludepids);
	$typeAhead.autocomplete({
		'alwaysOpenOnFocus': true,
		'source': autoCompleteUrl,
		'key': 'name',
		'queryParameter': 'term',
		'dataType': 'json',
		'minLength': 3,
		'maxResults': 20,
		'customDisplay': function (data) {
			var displayText = data.display;
			if (data.raw.birth !== '' || data.raw.death !== '') {
				displayText += ' ' + data.raw.birth + ' - ' + data.raw.death;
			}
			return {
				'value': data.value,
				'display': displayText
			};
		},
		'onOpen': function ($resultContainer, $before, $after) {
			if ($resultContainer === undefined) {
				$resultContainer = 0;
			}
			if ($before === undefined) {
				$before = 0;
			}
			if (showExtra) {
				$after.html($('#findPersonActions').html());
			}
		},
		'onItemSelect': function (itemData) {
			if (itemData !== '') {
				/* $(this).addClass('selectedPerson'); */
				/* Save out pid for use, and enable the save button */
				if (hasSection && section === 'personCard') {
					var pageUrl = window.PersonCard.URL.storyHref;
					switch ($('.tabActive').attr('id')) {
						case 'tabFacts':
							pageUrl = window.PersonCard.URL.factsHref;
							break;
						case 'tabGallery':
							pageUrl = window.PersonCard.URL.galleryHref;
							break;
						case 'tabHints':
							pageUrl = window.PersonCard.URL.hintsHref;
							break;
					}
					if (itemData.PID !== undefined) {
						pageUrl = pageUrl.replace(window.PersonCard.personId, itemData.PID);
					}
					window.location = pageUrl;
				}
				var $this = $(this);
				if ($this.length > 0) {
					$this.addClass('selectedPerson');
					if (itemData.PID !== '') {
						var $card = $this.closest('.card');
						$card.find('.erAddExistingData').data('itemData', itemData);
					}
				}
				if (typeAheadSaveButton !== undefined && typeAheadSaveButton !== null && typeAheadSaveButton.length > 0) {
					typeAheadSaveButton.removeAttr('disabled');
				}
			}
		}
	});
	$typeAhead.on('input', function () {
		$(this).removeClass('selectedPerson');
	});
}
/* Close Callouts */
function closeCallouts() {
	'use strict';
	$('.calloutTrigger.active').callout('close');
}
/* Since maxLength doesn't work on textareas, need a function to limit */
function CheckTextAreaLength(textBox, maxLength) {
	'use strict';
	var textBoxEl = $('#' + textBox.id);
	if (textBoxEl.length > 0) {
		if (textBoxEl.val().length > maxLength) {
			textBoxEl.val(textBoxEl.val().substring(0, maxLength));
		}
	}
}
/* Remove Person */
function removePerson() {
	'use strict';
	var pcName = escape(window.PersonCard.name);
	$.ajax({
		url: getPersonAjaxUrlPrefix() + window.PersonCard.URL.removePerson,
		type: 'POST',
		data: { name: pcName },
		success: function (data) {
			if (data && data.success) {
				location.href = data.returnUrl;
			}
			else {
				$.modal.close();
				if (data.message) {
					acom.bus.emit('Person::Notify::Failure', data.message, window.PersonCard.text.removePersonTitle);
				}
			}
		},
		error: function (msg) {
			if (msg && window.console) {
				console.log(msg);
			}
			/* error message */
		}
	});
}
/* Remove Person Modal */
function removePersonModal() {
	'use strict';
	closeCallouts();
	$(window.PersonCard.modals.deletePerson).modal({
		'onOpen': function () {
			$('#documentReturnURL').val(document.URL);
			$('#RemoveModalOkButton').one('click', function () {
				removePerson();
			});
		},
		'$trigger': $('.editToolsButton')
	});
}
/* Detach Media from a citation */
function detachMediaFromCitation(citationId, mediaId, callback) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/citationId/' + citationId + '/mediaid/' + mediaId + '/detachmediafromcitation';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (data.result && typeof (callback) === 'function') {
				callback(data);
			}
		},
		error: function () {
			window.lock.actionInProgress = false;
			window.personAnalyticsTrackClick('detachMediaFromCitation-Failed');
		}
	});
}
/* Detach Media from an event */
function detachMediaFromEvent(assertionId, mediaId, callback) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/assertionid/' + assertionId + '/mediaid/' + mediaId + '/detachmediafromevent';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (typeof (callback) === 'function') {
				callback(data, '#' + assertionId + 'mediaListCount');
			}
		},
		error: function () {
			window.lock.actionInProgress = false;
			window.personAnalyticsTrackClick('detachMediaFromEvent-Failed');
		}
	});
}
function setMediaViewerCropUrl() {
	'use strict';
	if ($('#cropProfileImage').length) {
		if ($html.hasClass('modalOpen') && $('#modal #chooseProfileImageModalContainer').length) {
			window.ancestry.pub.setCurrentPage('CurrentPersonView', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId });
			window.ancestry.pub
				.buildUrl()
				.toGoTo('MediaViewer', { 'MediaId': window.PersonCard.primaryImageId, 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'ShowImageCropping': 1 })
				.toComeBackToCurrent(true)
				.build(function (err, url) {
					if (!err) {
						window.location = url;
					}
				});
		} else {
			var options = {
				destInputs: { 'MediaId': window.PersonCard.primaryImageId, 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'ShowImageCropping': 1 },
				currentPageIsStart: true
			};
			window.ancestry.pub.getUrl('MediaViewer',
				options,
				function (e, url) {
					if (!e) {
						$('#cropProfileImage').attr('href', url);
						return false;
					}
				}
			);
		}
	}
}
function getProfileImageUrl() {
	'use strict';
	var url = window.PersonCard.domain.mediaSvc + '/v2/image/namespaces/1093/media/' + window.PersonCard.primaryImageId + '?client=PersonUI&maxSide=280';
	if (window.PersonCard.primaryImageCropRect) {
		url += '&ImageQuality=UltraHighQuality&scaleUpToMax=true&prescalecroprect=' + window.PersonCard.primaryImageCropRect;
	}
	return url;
}
function bindProfileImageClick(clicked, keypressed) {
	'use strict';
	function loadProfileImage() {
		var userCardImage = $('#personCard .userCardImg');
		if (window.PersonCard.primaryImageId) {
			userCardImage
				.removeClass('icon iconMale iconFemale iconPerson')
				.html('<img alt="" src="' + getProfileImageUrl() + '" />');
			setMediaViewerCropUrl();
		} else {
			userCardImage
				.addClass('icon icon' + window.PersonCard.gender)
				.find('img')
				.remove();
			bindProfileImageClick(false, false);
		}
	}
	function updatePersonProfileImage(mediaId, cropRect) {
		var url = window.PersonCard.domain.mediaAPI + '/api/trees/' + window.PersonCard.treeId + '/persons/' + window.PersonCard.personId,
			requestData = {
				mediaId: mediaId || ''
			},
			readCookie = function (name) {
				var c,
					ca = document.cookie.split(';'),
					i,
					nameEQ = name + '=';
				for (i = 0; i < ca.length; i += 1) {
					c = ca[i];
					while (c.charAt(0) === ' ') {
						c = c.substring(1, c.length);
					}
					if (c.indexOf(nameEQ) === 0) {
						return c.substring(nameEQ.length, c.length);
					}
				}
				return null;
			};
		$.ajax({
			type: 'PUT',
			url: url,
			data: JSON.stringify(requestData),
			contentType: 'application/json',
			beforeSend: function (request) {
				request.setRequestHeader('ATT', readCookie('ATT'));
			},
			success: function () {
				window.PersonCard.primaryImageId = requestData.mediaId;
				window.PersonCard.primaryImageCropRect = cropRect || '';
				loadProfileImage();
			},
			error: function () {
				if (window.acom !== null && window.acom.bus !== null) {
					window.acom.bus.emit('RemoveProfileImage::Notify::Failure', window.PersonCard.text.removeProfileImageError, window.PersonCard.text.removeProfileImageTitle);
				}
			}
		});
	}
	/* Show modal to choose new Profile Image for current person */
	function showChooseProfileImageModal() {
		var modalContainer = $('#chooseProfileImageModalContainer');
		function onMediaClick(mediaIds) {
			var mediaItem = mediaIds[0];
			updatePersonProfileImage(mediaItem.id, mediaItem.cropRect);
		}
		function selectorLoad() {
			/* Append the title once the content is loaded. */
			var $modalHeader = $('.modalHeader');
			if ($modalHeader.length) {
				$modalHeader.remove();
			}
			$('<div class="modalHeader"><h4 class="modalTitle">' + window.PersonCard.text.chooseProfileImageModalTitle.replace('{personName}', window.PersonCard.name) + '</h4></div>').prependTo(modalContainer);
		}
		if (window.acom && window.acom.bus) {
			window.acom.bus.on('Selector::selectionUpdated', onMediaClick);
			window.acom.bus.on('Selector::loaded', selectorLoad);
		}
		if (window.ancestry && window.ancestry.pub) {
			var options = {
				destInputs: {
					'TreeId': PersonCard.treeId,
					'PersonId': PersonCard.personId,
					'SelectedMediaIds': PersonCard.primaryImageId,
					'MediaTypesFilter': 'p'
				}
			};
			window.ancestry.pub.getUrl(
				'MediaSelectorComponent',
				options,
				function (e, url) {
					if (!e) {
						modalContainer.modal({
							'onOpen': function (modal) {
								if (window.ancestry && window.ancestry.pub) {
									window.ancestry.pub.setCurrentPage('CurrentPersonView', { 'TreeId': PersonCard.treeId, 'PersonId': PersonCard.personId }, true);
								}
								var glueOptions = {
									domId: 'chooseProfileImageModalContainer',
									url: url
								};
								window.glue.fetch(glueOptions);
								/* Setting min-height on this particular modal to fit full screen height */
								function resizeModalContentHeight($modal) {
									var modalCon = $modal.closest('.modalFlex'),
										modalConHeight = $(window).height() - parseInt(modalCon.css('margin-bottom'), 10) - parseInt(modalCon.css('margin-top'), 10),
										modalHeight = modalConHeight - parseInt(modalCon.css('padding-bottom'), 10) - parseInt(modalCon.css('padding-top'), 10);
									modalCon.css('min-height', modalConHeight);
									$modal.css('min-height', modalHeight);
								}
								resizeModalContentHeight(modal);
								/* Recalculate on window resize */
								$(window).on('resize.modal', function () {
									resizeModalContentHeight(modal);
								});
							},
							'onClose': function () {
								modalContainer.empty();
								if (window.acom && window.acom.bus) {
									window.acom.bus.off('Selector::selectionUpdated', onMediaClick);
									window.acom.bus.off('Selector::loaded', selectorLoad);
								}
								$(window).off('resize.modal');
							},
							'$trigger': $('#profileImage'),
							'useCustomPadding': true,
							'width': '100%'
						});
						return false;
					}
				}
			)
		}
	}
	if (PersonCard && window.PersonCard.hasEditRights && window.PersonCard.isProfileImageCropEnabled) {
		var $profileImage = $('#profileImage');
		if (window.PersonCard.primaryImageId) {
			if (!$profileImage.data('calloutInstance')) {
				$profileImage.callout({
					'classes': 'calloutMenu',
					'content': '#profileImageCalloutDomContent',
					'onOpen': function () {
						$('#chooseProfileImage').on('click', function () {
							showChooseProfileImageModal();
						});
						$('#removeProfileImage').on('click', function () {
							updatePersonProfileImage();
						});
					},
					'style': 'dark'
				});
				if (clicked === true || keypressed === true) {
					$profileImage.callout('open');
				}
			} else {
				if (keypressed === true) {
					$profileImage.callout('open');
				}
			}
		} else {
			if ($profileImage.data('calloutInstance')) {
				$profileImage.callout('destroy');
			}
			if (clicked === true || keypressed === true) {
				showChooseProfileImageModal();
			}
		}
	}
}
/*
	Updates profile image (add or remove)
	@param {string|undefined} mediaId Media Id. If present will update current profile picture with given media. If absent will remove profile picture all together.
	@param {string|undefined} cropRect Crop coordinates for profile image
*/
/* Show Add Media to LifeStory modal*/
function showAddMediaToLifeStoryModal() {
	'use strict';
	function showAddMediaLifestoryDetails(media) {
		function addMediaToLifeStory(response) {
			if (!response) {
				acom.bus.emit('AddMediaToLifeStory::Notify::Failure', PersonCard.text.addMediaToLifeStoryError, PersonCard.text.addMediaToLifeStoryModalTitle);
			}
			$.modal.close();
			window.glue.reload();
		}
		if (window.acom && window.acom.bus) {
			window.acom.bus.on('Details::onSave', addMediaToLifeStory);
			window.acom.bus.on('Details::onCancel', showAddMediaToLifeStoryModal);
		}
		var url = PersonCard.domain.mediaUI + '/component/details/' + PersonCard.treeId + '/' + PersonCard.personId + '/' + media.id;
		$('<div id="addTimelineMediaDetails">').modal({
			'onOpen': function () {
				var glueOptions = {
					domId: 'addTimelineMediaDetails',
					url: url
				};
				window.glue.fetch(glueOptions);
			},
			'onClose': function () {
				/* Unregister the handlers so they do not disrupt other details modals. */
				if (window.acom && window.acom.bus) {
					window.acom.bus.off('Details::onSave', addMediaToLifeStory);
					window.acom.bus.off('Details::onCancel', showAddMediaToLifeStoryModal);
				}
			},
			'$trigger': $('#optionsBtnAdd'),
			'width': '760'
		});
	}
	function filterMediaToAddToTimeline(items) {
		var attachedIds = PersonStory.timeline.events.reduce(function (obj, event) {
			if (event.EventMedia.length > 0) {
				obj[event.EventMedia[0].Id] = true;
			}
			return obj;
		}, {});
		items.forEach(function (item) {
			if (item !== null && attachedIds !== null && item.rights !== null) {
				if (item.date || attachedIds[item.id] || !item.rights.canEdit) {
					item.active = false;
				}
			}
		});
	}
	function mediaOnClick(items) {
		var media = items[0];
		showAddMediaLifestoryDetails(media);
	}
	function selectorLoad() {
		/* Append the title once the content is loaded. */
		$('<div class="modalHeader"><h4 class="modalTitle">' + window.PersonCard.text.addMediaToLifeStoryModalTitle + '</h4></div>').prependTo($('#addTimelineMedia'));
	}
	if (window.acom && window.acom.bus) {
		window.acom.bus.on('Selector::filterItems', filterMediaToAddToTimeline);
		window.acom.bus.on('Selector::selectionUpdated', mediaOnClick);
		window.acom.bus.on('Selector::loaded', selectorLoad);
	}
	$('<div class="modalHasTitle" id="addTimelineMedia">').modal({
		'onOpen': function () {
			closeCallouts();
			if (window.ancestry && window.ancestry.pub) {
				var options = {
					destInputs: {
						'TreeId': PersonCard.treeId,
						'PersonId': PersonCard.personId,
						'MediaTypesFilter': 'p',
						'Upload': '1'
					}
				};
				window.ancestry.pub.getUrl(
					'MediaSelectorComponent',
					options,
					function (e, url) {
						if (!e) {
							window.ancestry.pub.setCurrentPage('CurrentPersonView', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId });
							var glueOptions = {
								domId: 'addTimelineMedia',
								url: url
							};
							window.glue.fetch(glueOptions);
						}
					});
			}
		},
		'onClose': function () {
			/* Unregister the handlers so they do not disrupt other selector modals. */
			if (window.acom && window.acom.bus) {
				window.acom.bus.off('Selector::selectionUpdated', mediaOnClick);
				window.acom.bus.off('Selector::filterItems', filterMediaToAddToTimeline);
				window.acom.bus.off('Selector::loaded', selectorLoad);
			}
		},
		'$trigger': $('#optionsBtnAdd'),
		'width': '100%'
	});
}
/* Attach Media to an citation */
function attachMediaToCitation(citationId, mediaId, callback) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/citationId/' + citationId + '/mediaid/' + mediaId + '/attachmediatocitation';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (typeof (callback) === 'function') {
				callback(data);
			}
		},
		error: function () {
			window.lock.actionInProgress = false;
			window.personAnalyticsTrackClick('attachMediaToCitation-Failed');
		}
	});
}
/* Attach Media to an event */
function attachMediaToEvent(assertionId, mediaId, callback) {
	'use strict';
	var url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/assertionid/' + assertionId + '/mediaid/' + mediaId + '/attachmediatoevent';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (typeof (callback) === 'function') {
				callback(data);
			}
		},
		error: function () {
			window.lock.actionInProgress = false;
			window.personAnalyticsTrackClick('attachMediaToEvent-Failed');
		}
	});
}
/* Detach Source from an event */
function detachSourceFromEvent(assertionId, sourceId, selector, callback) {
	'use strict';
	/* handle onclick state */
	/* Perform the detach of the source to the event */
	var url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/assertionid/' + assertionId + '/sourceid/' + sourceId + '/detachsourcefromevent';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (typeof (callback) === 'function') {
				callback(data);
			}
		},
		error: function () {
			window.lock.actionInProgress = false;
			/* revert back on state if there is a problem with saving */
			window.updateSourceAttachDetachState(assertionId, sourceId, true, selector);
			window.personAnalyticsTrackClick('detachSourceFromEvent-Failed');
		}
	});
}
/* Attach Source to an event */
function attachSourceToEvent(assertionId, sourceId, selector, callback) {
	'use strict';
	/* handle onclick state */
	/* updateSourceAttachDetachState(assertionId, sourceId, true, selector); */
	/* Perform the attach of the source to the event */
	var url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/assertionid/' + assertionId + '/sourceid/' + sourceId + '/attachsourcetoevent';
	$.ajax({
		type: 'POST',
		url: url,
		cache: false,
		timeout: 20000,
		success: function (data) {
			if (typeof (callback) === 'function') {
				callback(data);
			}
		},
		error: function () {
			/* revert back on state if there is a problem with saving */
			window.updateSourceAttachDetachState(assertionId, sourceId, false, selector);
			window.personAnalyticsTrackClick('attachSourceToEvent-Failed');
		}
	});
}
function saveToTree() {
	'use strict';
	var saveToTreeModalTrigger = $('.saveToTree');
	if ($('.callout.open').length > 0) {
		if ($('.researchToolsButton').length) {
			saveToTreeModalTrigger = $('.researchToolsButton');
		} else {
			saveToTreeModalTrigger = $('.personToolsGuest');
		}
	}
	$('<div>').modal({
		'showLoading': true,
		'$trigger': saveToTreeModalTrigger,
		'width': '760',
		'onOpen': function ($this) {
			$.ajax({
				url: window.PersonCard.URL.saveToTree,
				type: 'GET',
				dataType: 'jsonp',
				contentType: 'application/json',
				jsonpCallback: 'handleJSON',
				success: function (response) {
					$.modal.showLoading(false);
					$this.html(
						'<div class="modalHasTitle">' +
						'<header class="modalHeader">' +
						'<h4 class="modalTitle">' + window.PersonCard.text.saveToTreeTitle + '</h4>' +
						'</header>' +
						response.html +
						'</div>'
					);
					$.getScript(response.js)
						.done(function () {
							return;
						})
						.fail(function () {
							$this.html(
								'<p>' + window.PersonCard.text.saveToTreeError + '</p>'
							);
						});
				},
				error: function () {
					$.modal.showLoading(false);
					$this.html(
						'<p>' + window.PersonCard.text.saveToTreeError + '</p>'
					);
				}
			});
		}
	});
}

function quickEdit(treeId, personId, trigger) {
	'use strict';
	/* this apmCallback (the lowest level callback), is to be used for screen refresh, modal close, and redirecting to a new page, or back to a modal */
	var apmCallback = function (cbResponse) {
		if (cbResponse.reqRefresh === true) {
			window.getPersonCard();
			$.modal.close();
			return false;
		}
		if (cbResponse.mode === 'm') {
			$.modal.close();
		}
		if (cbResponse.status === 'success') {
			window.personAnalyticsTrackClick('QuickEditPersonSaved');
			window.getPersonCard();
		}
		return true;
	};
	var pid = personId || window.PersonCard.personId,
		tid = treeId || window.PersonCard.treeId,
		$trigger = trigger || $('.editToolsButton');
	new AddPerson.Edit(tid, pid, {}, apmCallback, $trigger);
}
function addFamilyMember(tid, pid, args) {
	'use strict';
	/* this apmCallback (the lowest level callback), is to be used for screen refresh, modal close, and redirecting to a new page, or back to a modal */
	var apmCallback = function (cbResponse) {
		if (cbResponse.status === 'success') {
			window.personAnalyticsTrackClick('QuickEditPersonSaved');
			window.getPersonCard();
		}
		if (cbResponse.mode === 'm') {
			$.modal.close();
		}
		return true;
	};
	new AddPerson.Add(tid, pid, args, apmCallback);
}
/* Load Comment Count */
function loadCommentCount() {
	'use strict';
	var commentsCountUrl;
	if (window.PersonCard.URL.commentsCountUrl && window.PersonCard.URL.commentsCountUrl.length > 0) {
		commentsCountUrl = window.PersonCard.URL.commentsCountUrl;
		var commentData = {
			'Objects': [{
				'ObjectTypeId': '13',
				'ObjectId': window.PersonCard.treeId + ':' + window.PersonCard.personId,
			}]

		};
		$.ajax({
			url: commentsCountUrl,
			type: 'POST',
			contentType: 'application/json',
			cache: false,
			data: JSON.stringify(commentData),
			timeout: 20000,
			success: function (data) {
				var $commentsBadge = $('.commentsBadge'),
					$personCardCommentsBtn = $('#personCard .userCardInfo .personCommentsBtn'),
					$personCardUserCardInfo = $('#personCard .userCardInfo');
				function showCommentsInPersonCard(commentsButton) {
					if ($personCardUserCardInfo.length) {
						/* Using ".after" removes white space while ".append" leaves it. */
						$personCardUserCardInfo
							.children()
							.last()
							.after(commentsButton);
					} else {
						$('#personCard .userCardContent').append('<div class="userCardInfo">' + commentsButton + '</div>');
					}
				}
				if (data !== undefined && data.Counts !== undefined && data.Counts.length > 0) {
					if (data.Counts[0].Count) {
						var commentsCount = data.Counts[0].Count > 99 ? '99+' : data.Counts[0].Count,
							commentsAriaExpanded = ($('.pageWrapDrawer').length) ? 'true' : 'false',
							commentsBadge = '<span class="badge badgeColor1 commentsBadge">' + commentsCount + '</span>',
							commentsButton = '<button aria-controls="sideDrawer" aria-expanded="' + commentsAriaExpanded + '" class="link icon iconChat personCommentsBtn notPrintable" type="button"><span class="hideVisually">' + window.PersonCard.text.viewComments + '</span>' + commentsBadge + '</button>';
						if ($commentsBadge.length) {
							$commentsBadge.text(commentsCount);
							if (window.PersonCard.showCommentsInPersonCard === 'true' && !$personCardCommentsBtn.length) {
								showCommentsInPersonCard(commentsButton);
							}
						} else {
							$('.personCommentsBtn').append(commentsBadge);
							/* Show Comments in Person Card */
							if (window.PersonCard.showCommentsInPersonCard === 'true') {
								showCommentsInPersonCard(commentsButton);
							}
						}
						/* Print */
						$html.addClass('pFHasComments');
					} else {
						if ($commentsBadge.length) {
							$commentsBadge.remove();
							/* Remove Comments in Person Card */
							if (window.PersonCard.showCommentsInPersonCard === 'true') {
								$personCardCommentsBtn.remove();
								$('#personCard .userCardInfo:empty').remove();
							}
						}
						/* Print */
						$html.removeClass('pFHasComments pFShowingComments');
					}
				}
			}
		});
		return;
	}
}
function getPersonCard() {
	'use strict';
	$.ajax({
		cache: false,
		url: getPersonAjaxUrlPrefix() + window.PersonCard.URL.getPersonCard,
		type: 'GET',
		dataType: 'json',
		contentType: 'application/json',
		jsonpCallback: 'handleJSON',
		success: function (response) {
			var pcc = $('#personCardContainer');
			if (pcc.length > 0 && response.html !== '') {
				pcc.html(response.html);
				/* Add hidden accessibility text to profile image icon for users that have edit rights but don't have an image selected yet. */
				$('#profileImage.icon[role="button"]').html('<span class="hideVisually">' + window.PersonCard.text.chooseProfileImageModalTitle.replace('{personName}', window.PersonCard.name) + '</span>');
				/* Get notes and load the comment count */
				if (window.PersonCard.hasEditRights) {
					getPersonNotes();
					loadCommentCount();
				} else {
					loadCommentCount();
				}
				if (response.js !== undefined && personCardLoaded === undefined) {
					$.getScript(response.js)
						.done(function () {
							return;
						})
						.fail(function () {
							return;
						});
				}
				bindProfileImageClick(false, false);
			}
		},
		error: function () {
			return;
		}
	});
}
/* Person Page Availability */
function personPageAvailability(personPage) {
	'use strict';
	var $personPage = $('.personPage' + personPage);
	if ($personPage.attr('aria-busy') === 'true') {
		$personPage.removeAttr('aria-busy');
	} else {
		$personPage.attr('aria-busy', 'true');
	}
}
/* Supply an addedPid if you want to open the edit relationships modal after having added a new person */
function editRelationships(addedPid, addedRelation, isTransition) {
	'use strict';
	if (isTransition === undefined || isTransition === false) {
		window.closeCallouts();
	}
	var name = window.PersonCard.text.editRelsModalTitle.replace('{fullName}', $('#personCardContainer').find('.userCardTitle').html());
	$('<div class="modalPersonView modalEditRelationship form modalHasTitle" id="editRelationshipsModal"></div>').modal({
		'showLoading': true,
		'$trigger': $('.editToolsButton.calloutTrigger'),
		'useCustomPadding': false,
		'width': '760',
		'onOpen': function () {
			$.ajax({
				url: getPersonAjaxUrlPrefix() + window.PersonCard.URL.editRelationships,
				data: { addedPid: addedPid, addedRelation: addedRelation },
				type: 'GET',
				dataType: 'jsonp',
				cache: false,
				contentType: 'application/json',
				success: function (response) {
					$.modal.showLoading(false);
					$('.modalEditRelationship').html(response.html);
					$('.modalEditRelationship')
						.find('.modalTitle')
						.html(name);
					$.cachedScript(window.PersonCard.editRelationshipUrl).done(function () {
						/* initialize edit relationship ui actions */
						response.data.addedPid = addedPid;
						window.editRelationship(response.data);
					});
				},
				error: function () {
					$.modal.showLoading(false);
					$(this).html(
						'<div class="ancGrid ancGridPadded">' +
						'<div class="ancCol w100">' +
						'<p class="icon iconWarning">' + window.PersonCard.text.editRelationshipsError + '</p>' +
						'</div>' +
						'</div>'
					);
				}
			});
		},
		'onClose': function () {
			if (window.editRelationship && window.editRelationship.updated) {
				if (window.glue) {
					personPageAvailability('');
					window.glue.reload(function () {
						personPageAvailability('');
					});
				} else {
					location.reload();
				}
			}
			$.get(getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/relationship/log/modalclose');
		}
	});
}
function clearNarrativeCache() {
	'use strict';
	var ccUrl = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/clearnarrativecache';
	$.ajax({
		url: ccUrl,
		method: 'GET',
		async: false /* keep the DOM alive for this call, before redirecting over to something else like the Review Historical Insight */
	});
}
function setFactsMediaUploadWithHistoryUrl(ignore, assertionId) {
	'use strict';
	if (window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('CurrentPersonView', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId });
		window.ancestry.pub.buildUrl()
			.toGoTo('PersonFactMediaObjectUpload', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'AssertionId': assertionId, 'MediaType': 'Media' })
			.toComeBackToCurrent(true)
			.build(function (e, url) {
				if (!e) {
					window.location = url;
				}
			});
	}
}
function setCitationMediaUploadWithHistoryUrl(ignore, citationId) {
	'use strict';
	if (window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('PersonFactsCitationEdit', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'CitationId': citationId, 'TabName': 'Media' });
		window.ancestry.pub.buildUrl()
			.toGoTo('PersonCitationMediaObjectUpload', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'CitationId': citationId, 'MediaType': 'Media' })
			.toComeBackToCurrent(true)
			.build(function (e, url) {
				if (!e) {
					window.location = url;
				}
			});
	}
}
function setSearchWithHistoryUrl(clickAnchor) {
	'use strict';
	if (window.ancestry.pub) {
		var options = {
			destInputs: { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'SSRC': 'pt' },
			currentPageIsStart: true
		};
		window.ancestry.pub.setCurrentPage('CurrentPersonView', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId });
		window.ancestry.pub.getUrl('PersonRecordSearch',
			options,
			function (e, url) {
				if (!e) {
					clickAnchor.href = url;
					window.location = url;
					return false;
				}
			}
		);
	}
}
function setMergeDuplicateWithHistoryUrl(clickAnchor) {
	'use strict';
	if (window.ancestry.pub) {
		var options = {
			destInputs: { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'PersonIdPrimary': window.PersonCard.personId },
			currentPageIsStart: true
		};
		window.ancestry.pub.setCurrentPage('CurrentPersonView', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId });
		window.ancestry.pub.getUrl('PersonMergeDuplicatePickPerson',
			options,
			function (e, url) {
				if (!e) {
					clickAnchor.href = url;
					window.location = url;
					return false;
				}
			}
		);
	}
}
function setGalleryPubCurrentPage() {
	'use strict';
	if (window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('PersonViewMediaGallery', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId });
	}
}
function setHintsWithHistoryUrl() {
	'use strict';
	function setHintsPubCurrentPage(data) {
		if (window.ancestry.pub) {
			var inputs = { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId },
				pairs = location.search.slice(1).split('&'),
				index = 0;
			/* If there are any hint parameters, use those to set current page */
			/* By convention, strip of the ID string and capitalize the first letter of the param name */
			if (pairs[index].length) {
				var key,
					pair;
				for (index = 0; index < pairs.length; index += 1) {
					pair = pairs[index].split('=');
					if (pair && pair[0].startsWith && pair[0].startsWith('Hints.')) {
						key = pair[0].replace('Hints.', '');
						key = key.charAt(0).toUpperCase() + key.slice(1);
						inputs[key] = decodeURIComponent(pair[1] || '');
					}
				}
			}
			window.ancestry.pub.setCurrentPage('PersonPageHintsView', inputs, { 'successSource': 'Hint' });
			/* Emit the event so that any interested components get called */
			if (window.acom && window.acom.bus) {
				window.acom.bus.emit('csm::history::currentpagechange', data);
			}
		}
	}
	if (window.ancestry.pub) {
		/* Make the call to setCurrentPage using the current query string */
		setHintsPubCurrentPage({});
		/* Listen for the state change event and set current page accordingly */
		if (acom && acom.bus && acom.bus.listeners('csm::history::statechange').length < 1) {
			acom.bus.on('csm::history::statechange', setHintsPubCurrentPage);
		}
	}
}
function setViewRecordImageHistory(ignore, citationId) {
	'use strict';
	if (window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('PersonFactsCitationEdit', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'CitationId': citationId });
	}
}
function setViewRecordPageHistory(ignore, citationId) {
	'use strict';
	if (window.ancestry.pub) {
		window.ancestry.pub.setCurrentPage('PersonFactsCitationEdit', { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'CitationId': citationId });
	}
}
/* Convert HTML to Text */
function convertHTML(htmlVal) {
	'use strict';
	return $('<div/>').text(htmlVal).html();
}
/* Convert Text to HTML */
function convertText(textVal) {
	'use strict';
	return $('<div/>').html(textVal).text();
}
/* Toggle Checked Menu Items */
function toggleCheckedMenuItem(idVal) {
	'use strict';
	$(idVal)
		.addClass('loading loadingSmall loadingOnBlack')
		.closest('ul')
		.addClass('calloutCheckedMenuItemsDisabled');
}
/* Close MyCanvas Spotlight if needed */
function closeMyCanvasGuidance() {
	'use strict';
	if ($('.guidanceHighlight.spotlight').length === 1) {
		$printFriendlyActions.guidance('destroy');
	}
}
function setGalleryHistoryPoint() {
	'use strict';
	var setHistoryPoint = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/setgalleryhistorypoint';
	$.ajax({
		url: setHistoryPoint,
		method: 'GET',
		success: function () {
			return;
		}
	});
}
/* Print Close */
function closeBeforePrint() {
	'use strict';
	if ($html.hasClass('modalOpen')) {
		$.modal.close();
	}
	if ($('.callout').hasClass('active')) {
		closeCallouts();
	}
}
/* Print Before */
function beforePrint() {
	'use strict';
	/* Close */
	closeBeforePrint();
	/* Special Print Class */
	$html.addClass('pFNoTransitions');
	/* Facts Print */
	if ($('.pageHeader').hasClass('pageHeaderFacts')) {
		/* Reverse Sections */
		$('.factsSectionSources').insertAfter($('.factsSectionFamily'));
		/* Print */
		checkNotesAndComments();
	}
	/* Check Belay */
	if (typeof (beforeBelay) === 'function') {
		beforeBelay(false);
	}
}
/* Get Resolution */
window.getResolution = function () {
	'use strict';
	if (window.matchMedia('(min-resolution: 192dpi)').matches) {
		return 'retina';
	} else {
		return 'not-retina';
	}
};
/* Get Screen Type */
window.getScreenType = function () {
	'use strict';
	if (window.matchMedia('(max-width: 479px)').matches) {
		return 'smart-phone-portrait';
	} else if (window.matchMedia('(max-width: 767px)').matches) {
		return 'smart-phone';
	} else if (window.matchMedia('(width:768px)').matches) {
		return 'tablet-portrait';
	} else if (window.matchMedia('(max-width: 1005px)').matches) {
		return 'not-large-screen';
	} else {
		return 'large-screen';
	}
};
/* Person Screen Type */
window.personScreenType = function (type) {
	'use strict';
	if (type) {
		switch (type) {
			case 'not-large-screen':
				return window.matchMedia('(max-width: 1005px)').matches;
			case 'tablet-portrait':
				return window.matchMedia('(max-width: 768px)').matches;
			case 'smart-phone':
				return window.matchMedia('(max-width: 767px)').matches;
			case 'smart-phone-portrait':
				return window.matchMedia('(max-width: 479px)').matches;
			case 'large-screen':
			default:
				return window.matchMedia('(min-width: 1006px)').matches;
		}
	}
};
/* Before and After print for IE and FireFox */
window.onbeforeprint = beforePrint;
window.onafterprint = afterPrint;
window.glue = {};
window.lock = { actionInProgress: false };
/* Polyfill's IE11 */
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		'use strict';
		position = position || 0;
		return this.substr(position, searchString.length) === searchString;
	};
}
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (search, this_len) {
		'use strict';
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}
/* Used to fetch and cache dynamic javascript */
$.cachedScript = function (url, options) {
	'use strict';
	options = $.extend(options || {}, {
		dataType: 'script',
		cache: true,
		url: url
	});
	return $.ajax(options);
};
/* On Ready */
$(function () {
	'use strict';
	var $myCanvasLogoBtn = $('#myCanvasLogoBtn'),
		defaultGlueOptions = (window.PersonCard !== undefined) ?
			{
				/* Glue Defaults */
				key: window.PersonCard.tabName, /* Query key */
				queryValue: window.PersonCard.tabName, /* Updates url hash with the specified value */
				url: window.PersonCard.URL.current, /* The url that will serve glue Json */
				domId: window.PersonCard.domId, /* The DOM Id on which the default click needs to be subscribed */
				options: getTabData(window.PersonCard.tabName)
			} : {
				/* Glue Defaults */
				key: '', /* Query key */
				queryValue: '', /* Updates url hash with the specified value */
				url: '', /* The url that will serve glue Json */
				domId: '', /* Yhe DOM Id on which the default click needs to be subscribed */
				options: ''
			},
		glue = new window.Glue(defaultGlueOptions);
	/* FEM Logging */
	function setClicktaleCookie(cname, cvalue) {
		var d = new Date(),
			domainParts = /(?:ancestry((?:dev)?(?:stage)?(?:awsstage)?)\.)([a-z0-9]+(?:\.[a-z0-9]+)?)/i.exec(location.hostname);
		d.setMinutes(d.getMinutes() + 20);
		document.cookie = cname + "=" + cvalue + "; path=/; domain=." + domainParts[0] + "; expires=" + d.toGMTString();
	}
	function checkForError($page) {
		if ($page.find('.personPageUnavailable').length > 0) {
			$page.addClass('personPageError');
		}
	}
	/* Callback function for after view has been updated via glue */
	function showTabContent(options, $view) {
		$view.removeClass('loading loadingLarge');
		checkForError($('#' + options.domId));
	}
	/* We need to determine if we should be fetching a new glue model or waiting for the previous request to finish. */
	function updateView($view) {
		closeCallouts();
		$view.removeClass('personPageError');
		if (!$view.hasClass('loading')) {
			$view
				.addClass('loading loadingLarge')
				.children()
				.empty();
			return true;
		}
		return false;
	}
	function getCurrentViewName(id) {
		switch (id) {
			case 'tabFacts':
				return 'Facts';
			case 'tabGallery':
				return 'Gallery';
			case 'tabHints':
				return 'Hints';
			default:
				return 'Story';
		}
	}
	function renderView(tabId) {
		if (tabId !== 'tabStory') {
			$pageHeader
				.removeClass('pageHeaderStory pageHeaderFacts pageHeaderGallery pageHeaderHints')
				.addClass('pageHeaderNotStory pageHeader' + getCurrentViewName(tabId))
				.end()
				.find('#personCard .userCardEvents[aria-hidden]')
				.attr('aria-hidden', (window.personScreenType('smart-phone')) ? 'true' : 'false')
				.end()
				.find('#personCard .userCardSubTitle[aria-hidden]')
				.attr('aria-hidden', (window.personScreenType('smart-phone')) ? 'false' : 'true')
		} else {
			$pageHeader
				.removeClass('pageHeaderNotStory pageHeaderFacts pageHeaderGallery pageHeaderHints')
				.addClass('pageHeaderStory')
				.end()
				.find('#personCard .userCardEvents[aria-hidden]')
				.attr('aria-hidden', 'true')
				.end()
				.find('#personCard .userCardSubTitle[aria-hidden]')
				.attr('aria-hidden', 'false');
		}
		/* If the back or forward button was pressed while in print view we need to clear print view classes */
		if ($html.hasClass('printFriendly')) {
			clearPrintFriendly();
		}
	}
	/* Transition into the new view. */
	function changeView(tabId) {
		renderView(tabId);
	}
	/* Using browser back/foward buttons */
	function gluePreProcess(tab) {
		if (tab === 'csm') {
			return;
		}
		var data = getTabData(tab),
			$tab = $('#' + data.tabId);
		$tab
			.trigger('click')
			.focus();
		/* changeView calls renderView which updates classes on the pageHeader and, if needed, removes print friendly styles */
		changeView($tab.attr('id'));
	}
	/* Print Functions */
	function printFunction() {
		closeCallouts();
		$html.addClass('printFriendly');
		beforePrint();
		$('html, body').scrollTop(0);
		if (window.PersonCard.showMyCanvas && window.PersonCard.firstTimePrintView) {
			setTimeout(function () {
				$('#myCanvasLogoBtn').click();
			}, 0);
			/* set the flag that this user has now seen Print View before */
			$.ajax({
				url: getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/userhasseenprintview',
				method: 'GET'
			});
			window.PersonCard.firstTimePrintView = false;	/* set it also in javascript because the ajax call setting it server side won't reset the js variable until a page re-fresh */
			$('#myCanvasLogoBtn').focus();
		} else {
			$('#printFriendlyCustomizeBtn').focus();
		}
	}
	/* Tree Options Find a person callout and auto-complete */
	function findAPersonTreeOptionsPersonCard() {
		$('.treeOptions').callout({
			'classes': 'treeOptionsCallout',
			'content': '#personLookup',
			'onOpen': function () {
				personTypeAheadNameField($('#personLookupField'), '', null, 'personCard', true);
			},
			'onAfterOpen': function () {
				$('#personLookupField').focus();
			},
			'onClose': function () {
				$('.treeOptions').focus();
			}
		});
	}
	function toggleDrawerToTab(tabSelector) {
		closeCallouts();
		if (drawerIsOpen()) {
			if ($(tabSelector).hasClass('tabActive')) {
				toggleDrawer();
			} else {
				$(tabSelector)
					.click()
					.focus();
			}
		} else {
			toggleDrawer();
			$(tabSelector)
				.click()
				.focus();
		}
	}
	/* Research Toolbar */
	function researchToolbar() {
		var curView = '';
		if ($('.pageNav').hasClass('pageNavCollapsed')) {
			$('.pageNav')
				.removeClass('pageNavCollapsed')
				.addClass('pageNavExpanded');
			curView = 'Expanded';
			/*window.personToolsLinks();*/
		} else {
			$('.pageNav')
				.removeClass('pageNavExpanded')
				.addClass('pageNavCollapsed');
			curView = 'Collapsed';
			/*window.personToolsLinks();*/
		}
		closeCallouts();
		var tUrl = getPersonAjaxUrlPrefix() + '/northstar/personview/researchtoolbar?view=' + curView;
		$.ajax({
			cache: false,
			url: tUrl
		}).done(function () {
			return;
		});
	}
	function setMediaViewerUrl() {
		if ($('#viewProfileImage').length) {
			var options = {
				destInputs: { 'MediaId': window.PersonCard.primaryImageId, 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId },
				currentPageIsStart: true
			};
			window.ancestry.pub.getUrl('MediaViewer',
				options,
				function (e, url) {
					if (!e) {
						$('#viewProfileImage').attr('href', url);
						return false;
					}
				}
			);
		}
	}
	function getPersonHintsCount() {
		var hintsCountUrl;
		if (window.PersonCard.URL.hintsCountUrl && window.PersonCard.URL.hintsCountUrl.length > 0) {
			hintsCountUrl = window.PersonCard.URL.hintsCountUrl;
			$.ajax({
				url: hintsCountUrl,
				method: 'GET',
				cache: false,
				success: function (data) {
					if (typeof (data.PendingHintCount) === "undefined") {
						updateHintCount(data);
					} else {
						updateHintCount(data.PendingHintCount);
					}
				}
			});
			return;
		}
	}
	/* MyCanvas - for print mode */
	function buildMyCanvasUrl($link, pageId) {
		var options = { 'destInputs': { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId, 'PageId': pageId } };
		window.ancestry
			.pub
			.getUrl('MyCanvasPrint', options, function (err, url) {
				if (err && window.console !== null) {
					console.warn(err);
				}
				$link.attr('href', url);
			});
	}
	/* Setup the URL of the initial rendered view */
	new UpdateURL(History.getState(), defaultGlueOptions.options);
	/* setting up a global variable so we can access the glue reload function in other stacks (like trees) */
	if (window.glue) {
		glue.preProcess = gluePreProcess;
		window.glue.reload = glue.reload;
		window.glue.fetch = glue.fetch;
	}
	/* PersonCard object is defined in Person.aspx */
	window.acom.bus.on('csm::component::statechange', function () {
		if (window.PersonCard !== undefined && window.PersonCard.doHintsABTest !== undefined) {
			if (window.PersonCard.doHintsABTest === 'True' && typeof (window.mboxDefine) === 'function') {
				var userNameMbox = window.PersonCard ? window.PersonCard.name : '',
					userLifeRangeMbox = window.PersonCard ? window.PersonCard.lifeYearRange : '',
					userBirthPlace = window.PersonCard ? window.PersonCard.birthPlace : '',
					$hintCountDiv = $('.hint-count-pending'),
					hintNumberMbox = ($hintCountDiv.length > 0) ? $hintCountDiv.html() : '0';
				window.mboxUpdate('us_PersonsHintsTab', 'name=' + userNameMbox, 'lifeRange=' + userLifeRangeMbox, 'hintsAvail=' + hintNumberMbox, 'birthPlace=' + userBirthPlace);
			}
		}
	});
	window.acom.bus.on('Selector::deletePhoto', function (id) {
		var $pI = $('#profileImage').find('img');
		if ($pI.length > 0) {
			if ($pI.attr('src').indexOf(id) != -1) {
				window.getPersonCard();
			}
		}
	});
	/* notifications */
	window.notify({
		action: 'init',
		enableIpns: window.PersonCard.enableIPNS,
		ipnsUrl: window.PersonCard.ipnsUrl,
		cmsUrlBase: window.PersonCard.cmsUrlBase,
		handler: function (notifications) {
			if (window.console !== undefined) {
				window.console.log('IPNS:NOTIFICATIONS', notifications);
			}
			notifications.map(function (notifyItem) {
				if (notifications.hasOwnProperty(notifyItem)) {
					var notification = notifications[notifyItem];
					if (notification.action === 'Merge:Record') {
						notifyRecordObject = notification;
					}
				}
			});
			return true;
		}
	});
	checkForError($('.tabContent.tabActive .personPage'));
	/* Delay load js files that aren't needed on initial document load */
	loadScripts(window.PersonCard.jsAssets, getPersonHintsCount);
	/* Set the hints tab as the starting page if we are coming directly to the hints page. */
	if (window.location.href.toLowerCase().indexOf("/hints") !== -1) {
		setHintsWithHistoryUrl(null);
		/* Set current page if we are coming directly to the gallery page. */
	} else if (window.location.href.toLowerCase().indexOf("/gallery") !== -1) {
		setGalleryPubCurrentPage();
	}
	/* Load Family Search Button */
	if (window.PersonCard.showFsWidget) {
		var $TreesFunc = {
			/* Family Search Var */
			FamilySearch: {
				loadWidget: function (callback) {
					var qs = document.location.search || '';
					qs += (qs ? '&' : '?') + 'fsid=' + $('#familySearchId').val();
					$.ajax({
						cache: false,
						dataType: 'jsonp',
						xhrFields: {
							withCredentials: true
						},
						crossDomain: true,
						url: window.PersonCard.domain.trees + '/tree/' + $('#treeId').val() + '/person/' + $('#personId').val() + '/fs/personwidget' + qs
					}).done(function (response) {
						if (response !== null) {
							$('#fsWidget').html(response.html);
							if (callback !== null) {
								callback();
							}
							$('#fsDisconnectConfirm')
								.addClass('modalHasTitle')
								.removeClass('ancGrid ancGridSmall')
								.html(
								'<header class="modalHeader">' +
								'<h4 class="modalTitle">' + window.fsConfirmTitle + '</h4>' +
								'</header>' +
								'<div class="ancGrid ancGridSmall">' +
								$('#fsDisconnectConfirm').html() +
								'</div>'
								);
							$('#fsDisconnect').click(function () {
								$('#fsOrdStatus').callout('close');
								$('#fsDisconnectConfirm')
									.modal({
										'onOpen': function ($this) {
											$this
												.removeAttr('style')
												.one('click', '#fsConfirmDisconnect', function () {
													$.ajax({
														cache: false,
														dataType: 'jsonp',
														xhrFields: {
															withCredentials: true
														},
														crossDomain: true,
														url: window.PersonCard.domain.trees + window.fsPerformDisconnectUrl
													}).done(function (jsonResponse) {
														if (jsonResponse.success) {
															$('#familySearchId').val('');
															$.modal.close();
															location.reload();
														} else {
															$('#fsDisconnectFail')
																.addClass('modalHasTitle')
																.removeClass('ancGrid ancGridSmall')
																.modal({
																	'onOpen': function ($this) {
																		$this
																			.html(
																			'<header class="modalHeader">' +
																			'<h4 class="modalTitle">' + window.fsErrorDisconnecting + '</h4>' +
																			'</header>' +
																			'<div class="ancGrid ancGridSmall">' +
																			$this.html() +
																			'</div>'
																			)
																			.removeAttr('style');
																	},
																	'$trigger': $('#fsOrdStatus'),
																	'width': '510'
																});
														}
													});
												})
												.one('click', '#fsCancelDisconnect', function () {
													$.modal.close();
												});
										},
										'$trigger': $('#fsOrdStatus'),
										'width': '510'
									});
							});
						}
					}).fail(function () {
						$('#fsWidget')
							.parent('.familySearchTools')
							.remove();
					});
				}
			}
		};
		$TreesFunc.FamilySearch.loadWidget(function () {
			/* Remove the div that is only used to bring in the widget which wraps around the widget */
			$('#fsOrdStatus, #fsConnectLink, #fsConnectingStatus, #fsNeedsSignIn').unwrap();
		});
	}
	/* FEM Logging */
	if (PersonCard.doFEMLogging === "True") {
		setClicktaleCookie("ct_fire", "true");
	}
	/* Open Side Drawer on Load */
	if (toggleDrawerOnLoad === true) {
		toggleDrawer();
		if (andLoadComments === true) {
			loadComments();
		}
	}
	/* Tree Options */
	if (window.PersonCard.showFindAPerson) {
		findAPersonTreeOptionsPersonCard();
	}
	/* Get notes and load the comment count */
	if (window.PersonCard.hasEditRights) {
		getPersonNotes();
		loadCommentCount();
	} else {
		loadCommentCount();
	}
	$html.attr('data-page', window.PersonCard.tabName);
	$(window)
		.bind('pageshow', function (event) {
			if (event.originalEvent.persisted) {
				window.location.reload();
			}
		})
		.resize(ui.debounce(function () {
			/* Check Mini Profile */
			if (typeof checkMiniProfile === 'function') {
				checkMiniProfile();
			}
			/* Check Belay */
			if (typeof (beforeBelay) === 'function') {
				beforeBelay(false);
			}
		}, 250));
	/* Tab Events */
	$('#personTabs .tab').on('click.personView', function (e) {
		e.preventDefault();
		if (window.personScreenType('not-large-screen') && this.id === $('.tabs .tab.tabActive').attr('id')) {
			return;
		}
		var options = getTabData(this.id),
			$view = $('#' + options.contentId);
		$html.attr('data-page', options.queryValue);
		window.PersonCard.tabName = options.queryValue;
		options.pushUrlState = false;
		options.removeCacheFiles = false;
		options.callback = function () {
			showTabContent(options, $view, this);
		};
		if (updateView($view)) {
			glue.fetch(options);
		}
		/* Everytime we change views we push a new state */
		/* check to see if we are pushing the same state twice */
		var curState = History.getState();
		var tabName = getTabNameStringForPageTitle(options.queryValue);
		var tabTitle = htmlDecode(window.PersonCard.name) + ' - ' + tabName;
		if (curState.data.tab != options.key) {
			History.pushState({ tab: options.queryValue, domId: $view.attr('id'), options: options }, tabTitle, options.queryValue, false);
		}
	});
	/* Profile Image Callout */
	$html
		.on('click', '#profileImage', function () {
			bindProfileImageClick(true, false);/* (clicked, keypressed) */
		});
	$('#profileImage')
		.on('keypress', function (e) {
			/* Enter key pressed */
			if (e.which === 13) {
				bindProfileImageClick(false, true);/* (clicked, keypressed) */
			}
		});
	/* Research Tools Print */
	$('#researchTools .iconPrint').on('click', function () {
		$(this).addClass('printFriendlyViewTriggered');
		printFunction();
	});
	/* Tree Links Callout */
	if ($('#treePagesList > li').length > 0) {
		$('.treePagesButton').callout({
			'content': '#treePagesList',
			'classes': 'calloutMenu treePagesCallout'
		});
	}
	/* Person Type Callout */
	$('.pageActions .badge.iconInfo').callout({
		'classes': 'calloutOwner',
		'content': '#yourRoleDomCalloutDomContent'
	});
	/* Research Tools Callout */
	$('.researchToolsButton').callout({
		'classes': 'calloutMenu calloutMenuResearchTools',
		'content': '#researchToolsCalloutDomContent',
		'onOpen': function () {
			if ($('.pageNav').hasClass('pageNavExpanded')) {
				$('.researchToolsList .iconAfterCheck').addClass('calloutMenuChecked');
			} else {
				$('.researchToolsList .iconAfterCheck').addClass('calloutMenuUnchecked');
			}
			loadCommentCount();
		},
		'onAfterOpen': function () {
			$('.researchToolsList')
				.one('click', '.iconAfterCheck', function () {
					$(this).toggleClass('calloutMenuChecked calloutMenuUnchecked');
					researchToolbar();
					if ($(this).hasClass('calloutMenuChecked')) {
						window.personAnalyticsTrackClick('showResearchToolbar');
					} else {
						window.personAnalyticsTrackClick('hideResearchToolbar');
					}
				})
				.one('click', '.myNotesBtn', function () {
					toggleDrawerToTab('#myNotesTab');
				})
				.one('click', '.personCommentsBtn', function () {
					toggleDrawerToTab('#personCommentsTab');
				})
				.one('click', '.iconPrint', function () {
					$('.researchToolsButton').addClass('printFriendlyViewTriggered');
					printFunction();
				});
			if (!$('.pageHeader').hasClass('pageHeaderStory') && !$('.pageHeader').hasClass('pageHeaderFacts')) {
				$('.printOptionForLifeStoryAndFacts').addClass('printOptionForLifeStoryAndFactsHidden');
			} else {
				$('.printOptionForLifeStoryAndFacts').removeClass('printOptionForLifeStoryAndFactsHidden');
			}
		},
		'onClose': function () {
			$('.researchToolsList').off('click');
		}
	});
	/* Edit Tools Callout */
	$('.editToolsButton').callout({
		'classes': 'calloutMenu calloutMenuEditTools',
		'content': '#editToolsCalloutDomContent'
	});
	/* Guest Tools Callout */
	$('.personToolsGuest').callout({
		'classes': 'calloutMenu calloutMenuGuestTools',
		'content': '#guestToolsCalloutDomContent',
		'onOpen': function () {
			loadCommentCount();
		},
		'onAfterOpen': function () {
			$('.guestToolsList')
				.one('click', '.iconPrint', function () {
					$('.personToolsGuest').addClass('printFriendlyViewTriggered');
					printFunction();
				})
				.one('click', '.personCommentsBtn', function () {
					loadComments();
					toggleDrawerToTab('#personCommentsTab');
				});
			if (!$('.pageHeader').hasClass('pageHeaderStory') && !$('.pageHeader').hasClass('pageHeaderFacts')) {
				$('.printOptionForLifeStoryAndFacts').addClass('printOptionForLifeStoryAndFactsHidden');
			} else {
				$('.printOptionForLifeStoryAndFacts').removeClass('printOptionForLifeStoryAndFactsHidden');
			}
		},
		'onClose': function () {
			$('.guestToolsList').off('click', '.personCommentsBtn');
		}
	});
	/* Tag Callout */
	$('#completeTagBtn').callout({
		'content': '#completeTagCalloutDomContent',
		'onAfterOpen': function () {
			$('#completeTagCalloutDomContent')
				.off()
				.on('click', '.iconAfterCheck', function () {
					var currentTagId = $(this).attr('id'),
						removeTag = $(this).hasClass('calloutMenuChecked'),
						addOrRemoveArg = removeTag ? '/removepersontag' : '/addpersontag',
						url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/tag/' + currentTagId + addOrRemoveArg;
					/* Add loading icon and disable all tags */
					$(this)
						.addClass('loading loadingSmall loadingOnBlack')
						.closest('.calloutMenu')
						.find('button')
						.attr('disabled', 'disabled');
					/* Post tag update */
					$.ajax({
						cache: false,
						url: url,
						type: 'POST',
						dataType: 'json',
						contentType: 'application/json',
						success: function () {
							/* If successfull remove loading, toggle checkmark and get Person Card */
							$('#' + currentTagId)
								.toggleClass('calloutMenuUnchecked calloutMenuChecked loading loadingSmall loadingOnBlack')
								.closest('.calloutMenu')
								.find('button')
								.removeAttr('disabled', 'disabled');
							window.getPersonCard();
						},
						error: function () {
							/* If unsuccessfull posting tag update, just remove loading */
							$('#' + currentTagId)
								.removeClass('loading loadingSmall loadingOnBlack')
								.closest('.calloutMenu')
								.find('button')
								.removeAttr('disabled', 'disabled');
						}
					});
				});
		},
		'style': 'dark'
	});
	/* Tag Link */
	$('#personCardContainer').on('click', '.completeLink', function () {
		var title,
			explanation,
			tagId = $(this).attr('id');
		switch (tagId) {
			case 'MotherCompleteTag':
				title = window.PersonCard.text.motherComplete;
				explanation = window.PersonCard.text.motherCompleteUse;
				break;
			case 'FatherCompleteTag':
				title = window.PersonCard.text.fatherComplete;
				explanation = window.PersonCard.text.fatherCompleteUse;
				break;
			case 'ChildCompleteTag':
				title = window.PersonCard.text.childComplete;
				explanation = window.PersonCard.text.childCompleteUse;
				break;
			case 'SpouseCompleteTag':
				title = window.PersonCard.text.spouseComplete;
				explanation = window.PersonCard.text.spouseCompleteUse;
				break;
		}
		$(
			'<div class="modalHasTitle id="completeModal">' +
			'<header class="modalHeader">' +
			'<h4 class="modalTitle">' + title + '</h4>' +
			'</header>' +
			'<div class="ancGrid ancGridSmall">' +
			'<div class="ancCol w1oo">' +
			'<p>' + explanation + '</p>' +
			'</div>' +
			'</div>' +
			'</div >'
		).modal({
			'$trigger': $(this),
			'width': '400'
		});
	});
	$('.drawerHeader').on('click', '#personCommentsTab', loadComments);
	$('.relationshipLink').each(function () {
		var $this = $(this),
			url = getPersonAjaxUrlPrefix() + '/tree/' + window.PersonCard.treeId + '/person/' + window.PersonCard.personId + '/getrelationshiptext?page=unknown';
		$.ajax({
			url: url,
			type: 'GET',
			dataType: 'json',
			contentType: 'application/json',
			success: function (data) {
				if (data.content !== null) {
					$this.html(data.content);
				} else {
					/* error message */
					return;
				}
			},
			error: function () {
				/* error message */
				return;
			}
		});
	});
	$(document)
		.on('click', '.closeModal', function () {
			/* Close Modal */
			$.modal.close();
		})
		.on('click', '.closeCallouts', function () {
			/* Close Callout */
			closeCallouts();
		});
	/* Remove Focus state (per Ux), when clicking on cards, on cards when using a mouse */
	$('.personView .card').on('focus', function () {
		var $this = $(this);
		$this.one('mousemove', function () {
			$this.blur();
		});
	});
	/* Open the side drawer */
	$('.pageHeader')
		.off('click')
		.on('keydown', '.myNotesBtn', function () {
			$triggerToggleSideDrawer = $(this);
		})
		.on('keydown', '.personCommentsBtn', function () {
			$triggerToggleSideDrawer = $(this);
		})
		.on('click', '.myNotesBtn', function () {
			toggleDrawerToTab('#myNotesTab');
		})
		.on('click', '.personCommentsBtn', function () {
			toggleDrawerToTab('#personCommentsTab');
		});
	/* Close the side drawer */
	$('.sideDrawer').on('click', '#closeSideDrawerBtn', function () {
		toggleDrawer();
		checkNotesAndComments();
	});
	/* Update the comment count when adding, deleteing or undoing a comment */
	$('.tabContentComments')
		.on('click', '.comment .undo', function () {
			setTimeout(function () {
				loadCommentCount();
			}, 1000);
		})
		.on('click', '.comment button[data-ng-click="deleteComment(comment)"]', function () {
			setTimeout(function () {
				loadCommentCount();
			}, 1000);
			window.personAnalyticsTrackClick("deleteComment");
		})
		.on('click', '.actionButtons', function (event) {
			/* Adding a click event directly on the "add comment" button proved difficult with whatever angular is doing. This alternative fixes that, using target. */
			if ($(event.target).attr('data-ng-click') === 'deleteComment(comment)') {
				setTimeout(function () {
					loadCommentCount();
				}, 1000);
				window.personAnalyticsTrackClick("deleteComment");
			}
			if ($(event.target).attr('data-ng-click') === 'addComment()') {
				setTimeout(function () {
					loadCommentCount();
				}, 1000);
				window.personAnalyticsTrackClick("addComment");
			}
		});
	/* Open QuickEdit modal for SiteSanity if given a specific URL parameter */
	var params = window.location.search.substr(1).split('&'),
		p = params[0].split('=');
	if (p[0] === 'openTestQEModal') {
		quickEdit();
	}
	/* Print Webkit Before */
	if (window.matchMedia) {
		var mediaQueryList = window.matchMedia('print');
		mediaQueryList.addListener(function (mql) {
			if (mql.matches) {
				beforePrint();
			} else {
				afterPrint();
			}
		});
	}
	/* Notes and Comments */
	$('#myNotesTab')
		.on('keydown', function (e) {
			if (e.which === 9 && e.shiftKey) {
				e.preventDefault();
				$triggerToggleSideDrawer.focus();
			}
		})
		.on('click', function () {
			showingComments = false;
			showingNotes = true;
			checkNotesAndComments();
		});
	$('#personCommentsTab').on('click', function () {
		showingNotes = false;
		showingComments = true;
		checkNotesAndComments();
	});
	var typingTimer,                /* timer identifier */
		doneTypingInterval = 7500;  /* time in ms, 7.5 seconds */
	$('#NotesTextAreaNoEditor')
		.on('keyup', function () {
			function doneTyping() {
				savePersonNotes(clearChangesSavedText());
			}
			clearTimeout(typingTimer);
			typingTimer = setTimeout(doneTyping, doneTypingInterval);
		})
		.on('keydown', function () {
			clearTimeout(typingTimer);
			clearChangesSavedText();
		})
		.on('focus', function () {
			clearChangesSavedText();
		})
		.on('blur', function (e) {
			e.preventDefault();
			clearTimeout(typingTimer);
			setTimeout(function () {
				savePersonNotes(clearChangesSavedText());
			}, 25);
		});
	/* MBox */
	if (enablePrototypeMboxes === true) {
		mboxDefine('prototypeMBox', 'personPagePrototype');
		mboxUpdate('personPagePrototype');
	}
	var mBoxDiv = $('#htMBoxDiv');
	if (mBoxDiv.length > 0) {
		window.mboxDefine('htMBoxDiv', 'us_PersonsHintsTab');
	}
	/* Set href's */
	if (window.ancestry.pub) {
		/* Set href's for Tree links */
		$('.setTreeLink').each(function () {
			var $this = $(this),
				pubName = $this.attr('id'),
				options = {
					destInputs: { 'TreeId': window.PersonCard.treeId },
					currentPageIsStart: false
				};
			window.ancestry.pub.getUrl(pubName, options, function (e, url) {
				if (!e) {
					$this.attr('href', url);
					return false;
				}
			});
		});
		/* Set href for Military link */
		var options;
		if ($('#militaryBadgeLink').length) {
			options = {
				destInputs: { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId },
				currentPageIsStart: true
			};
			window.ancestry.pub.getUrl('PersonMilitaryPage',
				options,
				function (e, url) {
					if (!e) {
						$('#militaryBadgeLink').attr('href', url);
						return false;
					}
				}
			);
		}
		/* Set href for Member Connect link */
		if ($('.memberConnectLink').length) {
			options = {
				destInputs: { 'TreeId': window.PersonCard.treeId, 'PersonId': window.PersonCard.personId },
				currentPageIsStart: true
			};
			window.ancestry.pub.getUrl('PersonMemberConnect',
				options,
				function (e, url) {
					if (!e) {
						$('.memberConnectLink').attr('href', url);
						return false;
					}
				}
			);
		}
		/* Set href for Profile Callout Links */
		setMediaViewerUrl();
		setMediaViewerCropUrl();
	}
	/* Accessibility */
	$('#profileImage.icon[role="button"]').html('<span class="hideVisually">' + window.PersonCard.text.chooseProfileImageModalTitle.replace('{personName}', window.PersonCard.name) + '</span>');
	if (window.personScreenType('smart-phone') || $pageHeader.hasClass('pageHeaderStory')) {
		$pageHeader
			.find('#personCard .userCardEvents')
			.attr('aria-hidden', 'true')
			.end()
			.find('#personCard .userCardSubTitle')
			.attr('aria-hidden', 'false');
	} else {
		$pageHeader
			.find('#personCard .userCardEvents')
			.attr('aria-hidden', 'false')
			.end()
			.find('#personCard .userCardSubTitle')
			.attr('aria-hidden', 'true');
	}
	AjaxManager.send({
		url: bannersUrl, success: function () {
			var pageWrapRectTop = parseInt($pageWrap[0].getBoundingClientRect().top);
			/* Set top for Side Drawer */
			$sideDrawer.css('top', (pageWrapRectTop > 0) ? pageWrapRectTop + 'px' : '0px');
			/* Adjust top of Side Drawer during resize. */
			$(window)
				.off('resize.sideDrawer')
				.on('resize.sideDrawer', ui.debounce(function () {
					var pageWrapRectTopAfter = parseInt($pageWrap[0].getBoundingClientRect().top);
					if (pageWrapRectTop !== pageWrapRectTopAfter) {
						$sideDrawer.css('top', (pageWrapRectTopAfter > 0) ? pageWrapRectTopAfter + 'px' : '0px');
						pageWrapRectTop = pageWrapRectTopAfter;
					}
				}, 250));
		}
	});
	/* Print Callouts */
	$myCanvasLogoBtn.on('click', function () {
		closeCallouts();
		$printFriendlyActions.guidance({
			steps: [{
				'classes': 'spotlightMyCanvas',
				'content': '<div class="myCanvasPrintCallout" id="myCanvasSpotlightGuidance">' +
				'<section>' +
				'<p><small>In partnership with Ancestry.com</small></p>' +
				'<h3 class="noTopSpacing">MyCanvas allows you to print your family history.</h3>' +
				'<div class="myCanvasVisual topSpacing" role="presentation"></div>' +
				'<p class="topSpacing">Visit <a href="https://www.mycanvas.com/">MyCanvas.com</a> to create unique keepsakes<span class="breakMin768">using your family history.</span></p>' +
				'<footer class="topSpacing">' +
				'<a class="ancBtn ancBtnL full480 printFriendlyBtn topSpacing myCanvasBook">Family History Book</a>' +
				'<a class="ancBtn ancBtnM full480 printFriendlyBtn topSpacing myCanvasCalendar">Calendar</a>' +
				'<a class="ancBtn ancBtnR full480 printFriendlyBtn topSpacing myCanvasPoster">Family Tree Poster</a>' +
				'</footer>' +
				'</section>' +
				'<footer>' +
				'<p><small>MyCanvas is owned by Alexander&rsquo;s, a partner of Ancestry.com.<span class="breakMin768">Please review Alexander&rsquo;s <a href="https://www.mycanvas.com/terms-and-conditions/">Terms &amp; Conditions</a> and <a href="https://www.mycanvas.com/privacy-policy/">Privacy Policy</a>.</span></small></p>' +
				'</footer>' +
				'</div>',
				'heading': '',
				'onAfterOpen': function () {
					/* Create the MyCanvas URL's */
					if (window.ancestry !== undefined && window.ancestry.pub) {
						buildMyCanvasUrl($('.myCanvasBook'), 'book');
						buildMyCanvasUrl($('.myCanvasPoster'), 'poster');
						buildMyCanvasUrl($('.myCanvasCalendar'), 'calendar');
					}
				},
				'makeInteractable': true,
				'scroll': false,
				'selector': $myCanvasLogoBtn,
				'spotlight': $printFriendlyActions
			}]
		});
	});
});
